import { Base, StrictBase } from '@wilson/base';
import { User } from '../accounts/User';
import type { AbsenceCategory } from './absenceCategory';

export enum AbsenceStates {
  'open' = 'open',
  'accepted' = 'accepted',
  'declined' = 'declined',
  'withdrawn' = 'withdrawn',
}

export enum AbsenceDurationSegment {
  ByDay = 'by_day',
  ByTime = 'by_time',
}

export enum AbsenceCategoriesIdsMap {
  SickLeave = 'b83e4eca-5d2e-40cf-bf60-3f99d35885fc',
  Vacation = 'e3bbd273-c7bb-4fd3-99ba-d9daf1b11f64',
}

export interface AbsenceEntity {
  absentFrom: string;
  absentTo: string;
  status: AbsenceStates;
  userId: string;
  absenceCategoryId: AbsenceCategory['id'];
  halfDayStart?: boolean;
  halfDayEnd?: boolean;
  requestNote?: string | null;
  responseNote?: string | null;
}

export interface AbsenceFields extends AbsenceEntity {
  attachementUrl?: string;
  remark?: string;
  user?: User;
}

export type AbsenceWithCategory = Absence & {
  absenceCategory: AbsenceCategory;
};

export type AbsenceListItem = AbsenceWithCategory & {
  durationInDays: number;
  user: User;
};

export interface FindAbsencesListParams {
  absentFrom: string;
  absentTo: string;
  absenceCategoryIds?: string[];
  organizationalUnitIds?: string[];
  statusList?: AbsenceStates[];
  userIds?: string[];
  userLabelIds?: string[];
  searchText?: string;
}

export type AbsencesListSortOrder = 'ASC' | 'DESC';

export interface OrderAbsencesListParams {
  userName?: AbsencesListSortOrder;
  absenceCategoryName?: AbsencesListSortOrder;
  absentFrom?: AbsencesListSortOrder;
  absentTo?: AbsencesListSortOrder;
  createdAt?: AbsencesListSortOrder;
  durationInDays?: AbsencesListSortOrder;
  status?: AbsencesListSortOrder;
}

export type AbsenceWithConsumedDays = Absence & {
  consumedVacations: Date[];
};

export type AbsenceWithConsumedDaysAndCategory = AbsenceWithConsumedDays &
  AbsenceWithCategory;

export interface Absence extends AbsenceFields, Base {}

export type AbsenceWithDecision = Absence & {
  absenceDecisions: AbsenceDecision[];
  durationInDays: number;
};

export enum AbsenceDecisionLevel {
  HR = 'hr',
  Manager = 'manager',
  MasterDecider = 'masterDecider',
}

export interface AbsenceDecision extends StrictBase {
  userId: string;
  absenceId: string;
  decision: AbsenceStates;
  level: AbsenceDecisionLevel;
  absence: Absence;
  user: User;
}

export enum DayTypes {
  FullDay = 'full_day',
  FirstHalf = 'first_half',
  SecondHalf = 'second_half',
}

export type AbsenceWithDecisionAndHighlighted = AbsenceWithDecision & {
  id: string;
  isHighlighted: boolean;
};
